<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row>
        <el-col :span="3">
          <el-button type="success" icon="el-icon-search" @click="getVcardShares">重新获取</el-button>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column label="创建日期" min-width="100">
          <template slot-scope="scope">
            {{scope.row.create_dt | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="提示语" prop="title" min-width="200"></el-table-column>
        <el-table-column label="启用状态" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status === '启用'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否默认" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.is_default === '否'?'color:#EB5753':'color:#6FC334'">{{scope.row.is_default}}</span>
          </template>
        </el-table-column>
      </el-table>

    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.getVcardShares()
  },
  methods: {
    async getVcardShares() {
      this.$axios.post('/admin/Vcard/getVcardShares', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data
          this.tableData.forEach(e => {
            e.status = !e.status ? '终止' : '启用'
            e.is_default = !e.is_default ? '否' : '是'
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    }
  }

}
</script>

<style lang="less">
</style>
